import {addLoader, apiSlice, asyncToastDisplay, i18n} from "./apiSlice";

const dashboardFilterUrl = (route, publisherId, startDate, endDate) => {
  let url = `/publishers/${publisherId}/${route}`
  if (startDate && endDate) {
    url += `?date%5Bstart_date%5D=${startDate}&date%5Bend_date%5D=${endDate}`
  }
  return url
}

export const publisherApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPublishers: builder.query({
      query: () => {
        return {
          url: '/publishers'
        }},
      providesTags: (result = [], error, arg) => [{ type: 'Publisher', id: 'LIST' }],
    }),
    getPublisher: builder.query({
      query: ({publisherId, startDate, endDate}) => {
        return {
          url: dashboardFilterUrl("", publisherId, startDate, endDate)
        }},
      onQueryStarted: addLoader(),
      providesTags: (result = [], error, {publisherId, startDate, endDate}) => [{ type: 'Publisher', id: `kpis:${publisherId}:${startDate}:${endDate}` } ],
    }),
    createPublisher: builder.mutation({
      query: (publisher) => ({
        url: 'publishers',
        method: 'POST',
        body: publisher
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.created")}),
      invalidatesTags: [{ type: 'Publisher', id: 'LIST' }],
    }),
    updatePublisher: builder.mutation({
      query: (publisher) => ({
        url: `/publishers/${publisher.publisherId}`,
        method: 'PUT',
        body: publisher
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'Publisher', id: 'LIST' }, { type: 'Publisher', id: `admin:${arg.publisherId}` }, { type: 'Publisher', id: arg.slug }],
    }),
    getPublisherDataByDay: builder.query({
      query: ({publisherId, startDate, endDate}) => ({
        url: dashboardFilterUrl("data_by_day", publisherId, startDate, endDate)
      }),
      providesTags: (result = [], error, {publisherId, startDate, endDate}) => [{ type: 'Publisher', id: `data_by_day:${publisherId}:${startDate}:${endDate}`  }],
    }),
    getPublisherDevicesPerOs: builder.query({
      query: ({publisherId, startDate, endDate}) => ({
        url: dashboardFilterUrl("devices_per_os", publisherId, startDate, endDate)
      }),
      providesTags: (result = [], error, {publisherId, startDate, endDate}) => [{ type: 'Publisher', id: `devices_per_os:${publisherId}:${startDate}:${endDate}`  }],
    }),
    getPublisherConsents: builder.query({
      query: ({publisherId, startDate, endDate}) => ({
        url: dashboardFilterUrl("consents", publisherId, startDate, endDate)
      }),
      providesTags: (result = [], error, {publisherId, startDate, endDate}) => [{ type: 'Publisher', id: `consents:${publisherId}:${startDate}:${endDate}`  }],
    }),
    getPublisherApps: builder.query({
      query: ({publisherId, startDate, endDate}) => ({
        url: dashboardFilterUrl("apps", publisherId, startDate, endDate)
      }),
        providesTags: (result = [], error, {publisherId, startDate, endDate}) => [{ type: 'Publisher', id: `apps:${publisherId}:${startDate}:${endDate}`  }],
      }),
  }),
  overrideExisting: false
})

export const {
  useGetPublishersQuery,
  useGetPublisherQuery,
  useCreatePublisherMutation,
  useUpdatePublisherMutation,
  useGetPublisherDataByDayQuery,
  useGetPublisherDevicesPerOsQuery,
  useGetPublisherConsentsQuery,
  useGetPublisherAppsQuery
} = publisherApiSlice
